import { LicenseInfo } from '@mui/x-license';

const LICENSE_KEY =
  '8acb30e38c11095a0eae64875c56b52cTz05ODYyNixFPTE4MjUwNjA5NTI2OTEsUz1wcm8sTE09YW5udWFsLFBWPWluaXRpYWwsS1Y9Mg==';

export function activate(
  key: typeof LICENSE_KEY = LICENSE_KEY
): typeof LicenseInfo {
  if (key) {
    LicenseInfo.setLicenseKey(key);
  }
  return LicenseInfo;
}
